import React, { createContext, useState } from 'react';

export const CacheContext = createContext();

export const CacheProvider = ({ children }) => {
  const [cache, setCache] = useState({});

  const setCachedData = (key, data) => {
    setCache(prevCache => ({
      ...prevCache,
      [key]: data
    }));
  };

  return (
    <CacheContext.Provider value={{ cache, setCachedData }}>
      {children}
    </CacheContext.Provider>
  );
};
